'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumCautionTriangle = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.53167 3.12803C7.18767 2.00347 8.81253 2.00346 9.46852 3.12803L14.7275 12.1434C15.3886 13.2767 14.5711 14.7 13.2591 14.7H2.74114C1.42909 14.7 0.611609 13.2767 1.27271 12.1434L6.53167 3.12803ZM8.00005 6.29999C8.38665 6.29999 8.70005 6.61339 8.70005 6.99999V8.99999C8.70005 9.38659 8.38665 9.69999 8.00005 9.69999C7.61345 9.69999 7.30005 9.38659 7.30005 8.99999V6.99999C7.30005 6.61339 7.61345 6.29999 8.00005 6.29999ZM7.9988 12.0999C7.89297 12.0994 7.78827 12.0781 7.69073 12.037C7.5932 11.9959 7.50476 11.9359 7.43051 11.8605C7.35626 11.7851 7.29766 11.6957 7.2581 11.5975C7.21854 11.4994 7.1988 11.3943 7.2 11.2885C7.20585 11.0799 7.29189 10.8815 7.44023 10.7346C7.58858 10.5878 7.78781 10.5037 7.99652 10.5C8.4342 10.5 8.8056 10.8725 8.79989 11.3091C8.79572 11.5193 8.70967 11.7196 8.56004 11.8673C8.41042 12.015 8.20904 12.0984 7.9988 12.0999Z",
            fill: "currentColor"
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    d: "M8 14H13.259C14.0308 14 14.5116 13.1628 14.1227 12.4961L8.86378 3.48076C8.4779 2.81926 7.5221 2.81926 7.13622 3.48076L1.87726 12.4961C1.48837 13.1628 1.96925 14 2.74104 14H8Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M8 9V7",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.99886 12.0999C7.89303 12.0994 7.78833 12.0781 7.69079 12.037C7.59326 11.9959 7.50482 11.9359 7.43057 11.8605C7.35632 11.7851 7.29772 11.6957 7.25816 11.5975C7.2186 11.4994 7.19886 11.3943 7.20006 11.2885C7.20591 11.0799 7.29195 10.8815 7.44029 10.7346C7.58864 10.5878 7.78787 10.5037 7.99658 10.5C8.43426 10.5 8.80566 10.8725 8.79995 11.3091C8.79578 11.5193 8.70973 11.7196 8.5601 11.8673C8.41048 12.015 8.20911 12.0984 7.99886 12.0999Z",
                    fill: "currentColor"
                })
            ]
        })
    });
};

module.exports = MediumCautionTriangle;
